// Utilities
import { retry } from "@ms/uno-utilities/lib/local/RetryUtilities";
import { lazy } from "react";
export const PlannerDevPanelContainerLazyLoader = ()=>retry(()=>import(/* webpackChunkName: "planner-devpanelcontainer" */ "./PlannerDevPanelContainer")).then((bundle)=>{
        return {
            default: bundle.PlannerDevPanelContainer
        };
    });
export const LazyPlannerDevPanelContainer = /*#__PURE__*/ lazy(PlannerDevPanelContainerLazyLoader);
